module.exports = __webpack_public_path__ + "static/media/figmapan.6b594f6e.png";